/** Single source of truth for the dark-mode localStorage key. */
export const DARK_MODE_STORAGE_KEY = 'dark-mode';

export const getSystemPrefersDark = (): boolean => {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

/**
 * Explicit preference from storage: `null` when unset (follow OS).
 * Does not catch storage errors — callers decide the fallback.
 */
export const readDarkModeFromStorage = (): boolean | null => {
  const raw = localStorage.getItem(DARK_MODE_STORAGE_KEY);
  if (raw === null) {
    return null;
  }
  return raw === 'true';
};

/**
 * Effective dark mode: explicit localStorage value, or OS preference when unset.
 * Keep in sync with theme-bootstrap.js.
 */
export const resolveIsDarkMode = (): boolean => {
  try {
    const preference = readDarkModeFromStorage();
    return preference === null ? getSystemPrefersDark() : preference;
  } catch {
    return getSystemPrefersDark();
  }
};

export const writeDarkModeToStorage = (isDark: boolean): void => {
  try {
    localStorage.setItem(DARK_MODE_STORAGE_KEY, String(isDark));
  } catch {
    // ignore storage access errors
  }
};

export const clearDarkModeFromStorage = (): void => {
  try {
    localStorage.removeItem(DARK_MODE_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};
